.list {
    padding: 25px 0 20px;
    list-style-type: none;
    text-align: center;
    margin: 0;
}

.item {
    font-size: 1.25rem;
    display: inline-block;

    &.current {
        a {
            color: #000000;
        }
    }

    a {
        padding: 10px;
        text-transform: uppercase;
        color: var(--color-lobster);
        text-decoration: none;
        line-height: inherit;

        &:hover {
            color: var(--color-black);
        }
    }
}

.first {
    svg {
        width: 0.8em;
        height: 0.8em;
        fill: var(--color-lobster);
    }
}

.last {
    svg {
        width: 0.8em;
        height: 0.8em;
        transform: rotate(180deg);
        fill: var(--color-lobster);
    }
}
